import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { crmClient } from '../api/crmClient';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  CircularProgress
} from '@mui/material';
import type { SelectProps } from '@mui/material';

// The stages should match our backend Enum
const STAGES = ["Prospecting", "Qualification", "Proposal", "Negotiation", "Closed-Won", "Closed-Lost"];

interface DealStageSelectorProps {
  deal: {
    id: string;
    stage: string;
  };
}

export default function DealStageSelector({ deal }: DealStageSelectorProps) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (newStage: string) => 
      crmClient.patch(`/deals/${deal.id}`, { stage: newStage }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', deal.id] });
    },
  });

  const handleChange: SelectProps['onChange'] = (event) => {
    mutation.mutate(event.target.value as string);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControl sx={{ my: 2, minWidth: 200 }}>
        <InputLabel>Stage</InputLabel>
        <Select
          value={deal.stage}
          label="Stage"
          onChange={handleChange}
          disabled={mutation.isPending}
        >
          {STAGES.map(stage => (
            <MenuItem key={stage} value={stage}>{stage}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {mutation.isPending && (
        <CircularProgress size={24} sx={{ ml: 2 }} />
      )}
    </Box>
  );
} 